import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    userIsInternal: boolean;
  }>()
  .create(({ theme, userIsInternal }) => ({
    ticketCreateForm: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden'
    },
    ticketCreate: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      paddingBottom: theme.spacing(6),
      [theme.breakpoints.up('lg')]: {
        flexDirection: 'row'
      }
    },
    /* left column */
    ticketCreateColumnLeft: {
      width: '100%',
      '& > *': {
        marginBottom: theme.spacing(3)
      },
      [theme.breakpoints.up('md')]: {
        minWidth: '45rem'
      },
      [theme.breakpoints.up('lg')]: {
        paddingRight: userIsInternal ? theme.spacing(3) : 0
      }
    },
    columnLeftOrganizationName: {
      display: 'inline',
      fontSize: '2rem',
      fontWeight: 300
    },
    /* right column */
    ticketCreateColumnRight: {
      maxWidth: '100%',
      minWidth: '20rem',
      width: '100%',
      '& > :first-of-type': {
        marginTop: 0
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: '32rem'
      }
    },
    columnRightSection: {
      margin: `${theme.spacing(2)} 0`
    },
    columnRightSectionContent: {
      paddingLeft: theme.spacing(2)
    }
  }));

export default useStyles;
